<template>
  <div>
    <el-row style="height: 60px; margin-top: 20px">
      <el-col >
        <p><span>该功能用于控制子号可操作的功能项，打勾表示授权可操作</span></p>
        <p style="color: blue;margin-bottom: 30px"><span>该功能只能主号操作，子号无权操作。</span></p>

      </el-col>
    </el-row>
    <el-row  style="height: 60px;">
      <el-col>
        子号：<el-input v-model="subnick" size="small" style="width: 230px"></el-input>
        <el-button type="primary" size="small" @click="getPower">查询</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-checkbox-group v-model="checkedPower"  style="width: 400px">
          <el-checkbox v-for="item in powerOpto" :label="item.field" :key="item.title" style="margin-top: 20px;width:100px ">{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row  style="height: 60px; margin-top: 45px">
      <el-col>
        <el-button type="primary" @click="addPower" style="margin-left: 120px">保存权限</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
    export default {
        name: "Permission",  /*,{title:'查看隐私信息',field:'showcrypt'}*/
      data(){
          return{
            subnick:'',
            checkedPower:[],
            powerOpto:[{title:'快递模板',field:'temp'},{title:'快递打单',field:'print'},{title:'自由打单',field:'free'},
              {title:'同步订单',field:'gettrades'},{title:'查看订单',field:'showall'},
              {title:'批量发货',field:'sendgoods'},{title:'批量备注',field:'setmemo'},{title:'延长收货时间',field:'delay'},{title:'延长退款',field:'refund'},
              {title:'配货统计',field:'beihuodan'},{title:'商品管理',field:'getitems'},{title:'修改标题',field:'title'},{title:'查看预警',field:'warn'},],
          }
      },
      methods:{
        getPower:function () {
          let subnick=storage.get("subnick");
          if(subnick.length>0){
            this.$message.error("设置子号权限需要用主号登录后操作");
            return;
          }
          let param={
            subnick:this.subnick,
          }
          $api.post("/getPower", param, response=>{
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.checkedPower=dataResult.data.quanxian.split(",");
            }else{
              this.$message.error(dataResult);
            }

          })
        },
        addPower:function () {
          let nick=storage.get("nick");
          let subnick = storage.get("subnick");
          if(subnick != ""){
            this.$message.error("只能主号授权，子号无操作权限")
            return;
          }
          if(this.subnick.length == 0){
            this.$message.error("请输入子号，再设置权限")
            return;
          }
          if(this.subnick.indexOf(nick)<0){
            this.$message.error("您只能设置您名下的子号")
            return;
          }
          if(this.subnick.indexOf(":")<0){
            this.$message.error("您输入的子号格式不正确")
            return;
          }
          let index=this.subnick.indexOf(":");
          if(index==this.subnick.length-1){
            this.$message.error("请输入具体的子号名称")
            return;
          }
          let param={
            subnick:this.subnick,
            quanxian: this.checkedPower,

          }
          $api.post("/addPower", param, response=>{
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message.success("设置子号权限成功");
            }
            else{
              this.$message.error(dataResult);
            }
          })
        }
      },
      mounted(){
        let nick = storage.get("nick");
        if(nick == null){
          this.$message.error("您当前没有登录，请登录后进行操作！");
        }else {
          this.subnick = nick+":"
        }
      }
    }
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/page/Permission.vue